const getters = {
  webchat_id: (state) => state.webchat_id,
  webchat_demo: (state) => state.webchat_demo,
  webchat: (state) => state.webchat,
}

export default getters
